import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const YearlyPriceChart = ({ selectedAssets }) => {
  // Assuming 'selectedAssets' is an array of assets with a 'yearly_prices' object
  // Aggregate all years available across assets to ensure all possible years are covered
  const allYears = new Set();
  selectedAssets.forEach(asset => {
    Object.keys(asset.yearly_prices).forEach(year => allYears.add(year));
  });
  const sortedYears = Array.from(allYears).sort();

  // Create datasets for each asset
  const datasets = selectedAssets.map(asset => {
    return {
      label: asset.name, // Use the asset name as the label
      data: sortedYears.map(year => asset.yearly_prices[year] || null), // Use null for missing years to avoid plotting them
      fill: false,
      borderColor: `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`, // Random color for each asset
      tension: 0.5
    };
  });
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: 'rgb(255, 255, 255)', // Example legend text color
          font: {
            family: "'Roboto Slab', sans-serif" // Specify the font family
          }
        },
      },
      title: {
        display: true,
        text: 'Yearly Price Chart',
        font: {
          family: "'Roboto Slab', sans-serif", // Specify the font family for title
          size: 20,
        },
        color: '#3cf00f', // Title color
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,255,255,0.4)', // Light grid lines for the X axis
        },
        ticks: {
          color: '#3cf00f', // X axis tick color
          font: {
            family: "'Roboto Slab', sans-serif", 
            size: 14, // Specify the font family for axis labels
          },
        },
      },
      y: {
        grid: {
          color: 'rgba(255,255,255,0.4)', // Light grid lines for the Y axis
        },
        ticks: {
          color: '#3cf00f', // Y axis tick color
          font: {
            family: "'Roboto Slab', sans-serif",
            size: 14, // Specify the font family for axis labels
          },
        },
      },
    },
  };
  const data = {
    labels: sortedYears, // Use the aggregated and sorted years as labels
    datasets: datasets
  };

  return <Line options={options} data={data} />;
};

export default YearlyPriceChart;
